import { createSlice } from '@reduxjs/toolkit';

// Кириллица (uz-cyrl) убрана — у кого она была сохранена, интерфейс переключается на узбекский (латиница)
const SUPPORTED = ['uz', 'ru', 'en', 'tr'];
let savedLang = 'uz';
try {
  const v = localStorage.getItem('language');
  if (SUPPORTED.includes(v)) savedLang = v;
  else if (v) localStorage.setItem('language', 'uz');
} catch { /* ignore */ }

const langSlice = createSlice({
  name: 'lang',
  initialState: {
    current: savedLang,
  },
  reducers: {
    setLanguage: (state, action) => {
      state.current = action.payload;
      localStorage.setItem('language', action.payload);
    },
  },
});

export const { setLanguage } = langSlice.actions;
export default langSlice.reducer;
